/**
 * Converts ISO date string to human-readable string.
 * @param dateString ISO Date Time string of the format 13-07-2022T01:00:00
 * @returns {string} date in the format '13th Jul' if parseable else '-'
 */
export const getFormattedDate = (dateString, isReInductDatePlusOneFixEnabled) => {
    const date = new Date(dateString);
    if (isReInductDatePlusOneFixEnabled)
        date.setDate(date.getDate() + 1);
    if (!dateString || !(date instanceof Date) || isNaN(date)) return '-';
    return `${date.getDate()}${dateOrdinal(date.getDate())} ${date.toLocaleString('default', { month: 'short' })}`;
}

/**
 * Provide ordinal for date
 * @see https://stackoverflow.com/a/15397495
 * @param date The date of month
 * @returns {string} The ordinal for the date like, st, nd, rd, th
 */
export const dateOrdinal = (date) => {
    const dString = String(date);
    const last = +dString.slice(-2);
    if (last > 3 && last < 21) return 'th';
    switch (last % 10) {
        case 1:  return "st";
        case 2:  return "nd";
        case 3:  return "rd";
        default: return "th";
    }
}



// WEBPACK FOOTER //
// ./src/components/utils/DateTimeUtils.js